export const appPageDataHooks = {
  APP_PAGE_COMPONENT: 'app-page-component',
  APP_STICKY_HEADER_CTA: 'app-sticky-header-cta',
  BACK_BUTTON: 'back-button',
  RECOMMENDED_FOR_YOU_SECTION: 'recommended-for-you-section',
  CATEGORIES_TAGS: 'categories-tags',
  EXTERNAL_PRICING_LINK_BUTTON: 'external-pricing-link-button',
  APP_PAGE_CTA: 'app-page-cta',
};
